import React from 'react';
import ReactModal from 'react-modal';
import './Modal.sass';

const defaultModalProps = {
  isOpen: true,
  className: 'EviteModal__Content',
  overlayClassName: 'EviteModal__Overlay',
  closeTimeoutMS: 200,
};

ReactModal.setAppElement('#modalRoot');

export const Modal = (props) => {
  if (!props.onClose) console.log('Missing required onClose prop for Modal');
  const combinedProps = {
    ...defaultModalProps,
    ...props,
  };
  return <ReactModal {...combinedProps} />;
};
